import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Extensions } from 'src/app/shared/extensions/extensions';
import { FOOTER_LINKS } from './_consts/footer-links.const';
import { Footer } from './_models/footer.model';
import { CommonModule } from '@angular/common';
import { FooterTopComponent } from './footer-top/footer-top.component';
import { FooterProductsComponent } from './footer-products/footer-products.component';
import { FooterContentComponent } from './footer-content/footer-content.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FooterTopComponent,
    FooterProductsComponent,
    FooterContentComponent
  ]
})
export class FooterComponent implements OnInit {
  content: Footer;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    this.translateService.get('FOOTER').subscribe((footerTexts: Footer) => {
      this.content = Extensions.deepMerge(footerTexts, FOOTER_LINKS) as Footer;
    });
  }
}
